import React from 'react';
import TwoColumns from './TwoColumns';
import VideoPlayer from './VideoPlayer';
import BackgroundImage from './BackgroundImage';
import SharedHeroImage from '../../images/bg-diagonal.webp';

interface HeroWithVideoProps {
  heroContent: React.ReactNode;
  videoTitle: string;
  videoUrl: string;
}

const HeroWithVideo = ({
  heroContent,
  videoTitle,
  videoUrl,
}: HeroWithVideoProps) => (
  <BackgroundImage imageUrl={SharedHeroImage}>
    <TwoColumns
      sx={{
        '@media screen and (min-width: 1800px)': {
          minHeight: '1100px',
        },
      }}
      minH={{ base: '950px', lg: '790px', xl: '790px' }}
      col1={heroContent}
      col2={<VideoPlayer title={videoTitle} src={videoUrl} />}
    />
  </BackgroundImage>
);
export default HeroWithVideo;
